<template>
    <div class="flex flex-row items-center justify-center space-x-4">
        <div class="flex flex-col space-y-1 text-center">
            <!-- <Avatar :avatar="horse.avatar" :read-only="true" /> -->
            <Avatar :avatar="horse.avatar" :read-only="readOnly" @update:avatar="updateAvatar" :small="small" />

            <div v-if="owners && displayOwners" class="flex items-center justify-center text-center">
                <div class="bg-dark-light w-fit rounded-full px-2 py-1 text-xs leading-4 tracking-widest text-white">
                    <Tooltip>
                        {{ $t('horse.owner', owners.split('/').length) }}: {{ owners }}
                        <template #tooltip>
                            {{ $t('team.are-you-owner') }}
                            <a :href="'mailto:' + supportEmail + '?subject=Horse #' + horse.id" class="text-brand-base">
                                {{ supportEmail }}.
                            </a>
                        </template>
                    </Tooltip>
                </div>
            </div>

            <template v-if="displayOwners">
                <div class="flex items-center justify-center text-center">
                    <div
                        class="bg-dark-light flex w-fit items-center justify-center space-x-2 rounded-full px-2 py-1 text-center text-xs leading-4 tracking-widest text-white"
                    >
                        <div>{{ $t('user.job.vet', owners.split('/').length) }}:</div>
                        <div v-if="veterinarians">{{ veterinarians }}</div>
                        <div v-else>
                            <!-- Only owners can invite (the API refuses anyone else). -->
                            <AddLink v-if="horse.can_edit" :action="() => (openAddVetModal = true)" />
                            <span v-else>—</span>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <div class="flex flex-col space-y-1 text-center">
            <h2>{{ horse.name }}</h2>
            <Text v-if="horse.born_at">
                {{ format(horse.born_at, 'YYYY-MM-DD') }} {{ horse.born_at && `(${getAge(horse.born_at)})` }}</Text
            >
            <Text>{{ horse.breed }}</Text>
        </div>
        <AddVetModal :horse="horse" v-model:is-open="openAddVetModal" />
    </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { format } from '@/lib/helpers/time'
import { getAge } from '@/lib/helpers/time'

import AddLink from '@/components/buttons/AddLink.vue'
import Text from '@/components/Text.vue'
import TooltipElement from '@/components/Tooltip.vue'
import Avatar from '@/components/Avatar.vue'
import AddVetModal from '@/components/modals/AddVetModal.vue'

const props = defineProps({
    horse: { type: Object, required: true }, // Horse object
    readOnly: { type: Boolean, default: false }, // Set if avatar can be edited
    small: { type: Boolean, default: false }, // Small size version
    displayOwners: { type: Boolean, default: true },
})

const emits = defineEmits(['update:avatar'])

const openAddVetModal = ref(false)

const supportEmail = import.meta.env.VITE_APP_SUPPORT_EMAIL

const owners = computed(() =>
    props.horse?.users
        ? props.horse?.users
              .filter((user) => user.is_owner)
              .map((owner) => {
                  return `${owner.first_name} ${owner.last_name}`
              })
              .join(' / ')
        : ''
)

const veterinarians = computed(() =>
    props.horse?.users
        ? props.horse?.users
              .filter((user) => user.is_vet)
              .map((vet) => {
                  return `${vet.first_name} ${vet.last_name}`
              })
              .join(' / ')
        : ''
)

const updateAvatar = (file) => {
    emits('update:avatar', file)
}
</script>
